<stages-dialog2 #dialog [dialogAriaLabel]="'files.template.title' | translate">
	<stages-dialog-header />
	@if (credentialsValid) {
		@if (fileTemplateForm) {
			<span class="h1" translate="files.start.template.title"></span>
			<article class="description">
				<p translate="files.template.info"></p>
			</article>
			<form class="content file-add-dialog" [formGroup]="fileTemplateForm" #formElement>
				<article class="form properties">
					<div class="input-container">
						<label for="files-template-templatesource" class="input-label" translate="files.template.templatesource">
						</label>
						<select id="files-template-templatesource" [formControlName]="'templateSelection'" class="select fullsize">
							@for (template of templateSelectionValues; track template) {
								<option [value]="template.fileId">
									{{ template.name }}
								</option>
							}
						</select>
						@if (templateSelectionValues.length < 1) {
							<p translate="file.template.error.notemplateavailable"></p>
						}
						<div class="info"></div>
					</div>
					<div class="input-container required">
						<label for="files-template-filename" class="input-label" translate="files.template.filename"></label>
						<input
							id="files-template-filename"
							stagesTrim
							[formControlName]="'fileName'"
							class="text fullsize"
							(input)="updateButtons()"
						/>
						<div class="label info">
							@if ((fileNameControl.dirty || fileNameControl.touched) && fileNameControl.errors) {
								<div class="errors">
									@if (fileNameControl.errors["required"]) {
										<div class="error" translate="input.required"></div>
									}
									@if (fileNameControl.errors["serverSideError"]) {
										<div class="error">
											{{ fileNameControl.errors["serverSideError"] }}
										</div>
									}
									@if (fileNameControl.errors["maxlength"]) {
										<div class="error" translate="input.maxLength" [translateParams]="{ length: 255 }"></div>
									}
								</div>
							}
							<div class="maxlength">{{ fileNameControl.value.length }}/255</div>
						</div>
					</div>
				</article>
				<article class="form properties">
					<stages-attribute-edit
						[attributeTypes]="fileProperties.attributeTypes"
						[attributes]="fileProperties.attributes"
						[form]="fileTemplateForm"
					>
					</stages-attribute-edit>
				</article>
			</form>
			<footer>
				<div class="buttons-bottom">
					<div class="spacer"></div>
					@if (!fileIsAlreadyLinked) {
						<button
							class="button sm cancel"
							ngClass="action.buttonClass"
							translate="cancel"
							(click)="closeCancel()"
							[disabled]="isLoading"
						></button>
						<button
							class="button sm save"
							ngClass="action.buttonClass"
							[disabled]="isButtonDisabled()"
							(click)="saveAndDownloadFile(fileProperties)"
						>
							@if (!isLoading) {
								<span translate="files.template.submit"></span>
							}
							@if (isLoading) {
								<stages-spin [size]="'sm'"></stages-spin>
							}
						</button>
					}
					@if (fileIsAlreadyLinked) {
						<button class="button sm" ngClass="action.buttonClass" (click)="closeCancel()">
							<span translate="files.template.ok"></span>
						</button>
					}
				</div>
			</footer>
		} @else {
			@if (loadingError$ | async; as error) {
				<span class="h1" translate="error.title"></span>
			}
			<stages-popup-content>
				<stages-loading-error-embeddable [credentialsValid]="credentialsValid" [loadingError$]="loadingError$" />
			</stages-popup-content>
			<stages-popup-footer [hasCancelButton]="false" [buttons]="buttons" />
		}
	} @else {
		@if (!credentialsValid && !oAuthUrl) {
			<stages-files-auth-embeddable #auth [cmsTypeMessageKey]="cmsTypeMessageKey!" />
		}
		@if (!credentialsValid && oAuthUrl) {
			<stages-files-oauth-embeddable-confirm
				[cmsTypeMessageKey]="cmsTypeMessageKey!"
				[authUrl]="oAuthUrl"
				[closeCallback]="close"
			/>
		}
	}
</stages-dialog2>
